import styled from '@emotion/styled'
import { Trans, useTranslation } from 'react-i18next'

import { MatchSource } from 'src/graphql/types'
import { useProfile } from 'src/hooks/use-profile'
import { useRouting } from 'src/routes'
import { RelativeLink } from 'src/system/ui/link/RelativeLink'
import { LoadingSpinner } from 'src/system/ui/LoadingSpinner'
import { LinkFaceit } from 'src/screens/account/faceit/LinkFaceit'

export function SourceEmptyState(props: { source: MatchSource }) {
  const { t } = useTranslation()
  const { routes } = useRouting()
  const { profile, loading } = useProfile('cache-first')

  if (props.source === MatchSource.Faceit) {
    // Until the profile has loaded, the link state is unknown — show the
    // spinner rather than flashing the link button at already-linked users.
    if (!profile) {
      return loading ? (
        <LoadingSpinner />
      ) : (
        <div>{t('matches:source_empty:faceit')}</div>
      )
    }
    if (!profile.faceit) {
      return (
        <div>
          <Prompt>{t('matches:source_empty:faceit_unlinked')}</Prompt>
          <LinkFaceit />
        </div>
      )
    }
  }

  if (props.source === MatchSource.Upload) {
    return (
      <div>
        <Trans i18nKey='matches:source_empty:upload'>
          {' '}
          <RelativeLink to={routes.account}> </RelativeLink>
        </Trans>
      </div>
    )
  }

  return <div>{t(`matches:source_empty:${props.source}`)}</div>
}

const Prompt = styled.p`
  margin: 0 0 ${(props) => props.theme.d.spacing[3]};
`
